var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isActive,
          expression: "isActive",
        },
      ],
      staticClass: "bulma-message-modal",
    },
    [
      _c("div", {
        staticClass: "bulma-message-modal-backdrop",
        on: { click: _vm.handleBackdropClick },
      }),
      _c(
        "article",
        {
          staticClass: "message bulma-message-modal-panel",
          class: _vm.type + " " + (_vm.$theme.isDark ? "is-dark" : "is-light"),
        },
        [
          _vm.hasHeader
            ? _c(
                "header",
                {
                  staticClass:
                    "message-header is-flex is-justify-content-space-between",
                },
                [
                  _c(
                    "span",
                    { staticClass: "is-flex is-align-items-center" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "msr msr-24px mr-2",
                          style: { color: _vm.iconColorCode || "" },
                        },
                        [_vm._v(_vm._s(_vm.iconName))]
                      ),
                      _vm._t("title", function () {
                        return [_vm._v(" " + _vm._s(_vm.title) + " ")]
                      }),
                    ],
                    2
                  ),
                  _vm.closable
                    ? _c("span", [
                        _c(
                          "span",
                          {
                            staticClass:
                              "msr msr-24px mr-2 is-flex is-align-items-center is-cursor-pointer",
                            on: { click: _vm.close },
                          },
                          [_vm._v("close")]
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _c(
            "section",
            { staticClass: "message-body" },
            [
              _vm._t("default"),
              _c(
                "div",
                { staticClass: "bulma-message-modal-footer pt-5 pb-0 px-0" },
                [
                  _vm._t("footer", function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v(" Dismiss ")]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }